import { anim, prog, stagger } from '../../../motion'
import { BeamBands, COLORS, Check } from '../../../primitives'
import { Line, Words } from '../../../v2/kit'
import { useCopy } from '../../i18n'
import { DIMS } from '../copy'

const EXPERT_COLORS = ['blue', 'pink', 'yellow']

// Drei Quellen zur Wahl, dann setzen drei Personen ihre Punkte und das Profil wächst
export default function DemoRequirements() {
  const c = useCopy('analyse')
  const dims = useCopy('dims')

  return (
    <div className='cin-pad'>
      <div className='cin-head'>
        <Line at={[0, 0.06]} className='cin-eyebrow'>
          {c.eyebrow}
        </Line>
        <h2 className='cin-title'>
          <Words text={c.title} at={[0.02, 0.16]} />
        </h2>
      </div>

      <div className='dm-sources-pick'>
        {c.sources.map((s, i) => (
          <div
            key={s}
            className='dm-pick'
            style={{
              ...anim({ at: stagger(0.06, 0.03, 0.08, i), y: 30 }),
              ...(i === 0 ? prog([0.18, 0.22]) : {})
            }}
          >
            {i === 0 && (
              <span className='dm-pick__check'>
                <Check size={22} color='blue' />
              </span>
            )}
            {s}
          </div>
        ))}
      </div>

      <div className='cin-profile dm-profile'>
        <div
          className='cin-profile__legend'
          style={anim({ at: [0.2, 0.26], y: 16 })}
        >
          {c.experts.map((e, i) => (
            <span key={e} className='cin-legend-item'>
              <i style={{ background: COLORS[EXPERT_COLORS[i]] }} />
              {e}
            </span>
          ))}
          <span className='cin-legend-item'>
            <i
              className='cin-swatch'
              style={{ background: 'rgb(167 247 231)' }}
            />
            {c.target}
          </span>
          <span className='cin-legend-item'>
            <i
              className='cin-swatch'
              style={{ background: 'rgb(253 218 148)' }}
            />
            {c.tolerance}
          </span>
        </div>

        {DIMS.map((d, row) => (
          <div key={d.key} className='cin-profile__row'>
            <div
              className='cin-profile__label'
              style={anim({ at: stagger(0.2, 0.02, 0.08, row), x: -30, y: 0 })}
            >
              {dims[d.key]}
              {d.must && <span className='dm-must'>{c.must}</span>}
            </div>
            <div className='cin-profile__track'>
              <BeamBands
                ideal={d.ideal}
                trans={d.trans}
                at={stagger(0.6, 0.03, 0.12, row)}
              />
              {d.experts.map((v, e) => (
                <div
                  key={e}
                  className='cin-profile__pin'
                  style={{ left: `${v}%` }}
                >
                  <div
                    className='cin-profile__dot dm-profile__dot'
                    style={{
                      background: COLORS[EXPERT_COLORS[e]],
                      ...anim({
                        at: stagger(0.28 + e * 0.08, 0.02, 0.08, row),
                        y: -320,
                        s: 0.4
                      })
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className='cin-chips' style={anim({ at: [0.78, 0.86], y: 24 })}>
        {c.chips.map((chip, i) => (
          <span
            key={chip}
            className={i === 2 ? 'cin-chip cin-chip--blue' : 'cin-chip'}
          >
            {chip}
          </span>
        ))}
      </div>
    </div>
  )
}
